import type { Flow } from '../../../modules/Auth0/types';
import { mapError } from '../../../modules/Auth0/utils/mapError';
import type { Analytics } from '../../../modules/analytics/types';
import { captchaEvent } from '../../../modules/metrics';

import { logError } from './utils';

export let captchaWidget: any;

const renderCaptchaCheckbox = async (
  analytics: Analytics,
  flow: Flow,
  googleCaptchaSiteKey: string,
  attempt: number = 1,
): Promise<string | undefined> =>
  new Promise((resolve, reject) => {
    const { trackLink } = analytics;
    const errorReason = mapError(
      {
        code: 'recaptcha_error',
        name: 'error_rendering_recaptcha',
        error: 'error_rendering_recaptcha',
      },
      trackLink,
      `${flow}.error_rendering_recaptcha`,
    );
    try {
      const { grecaptcha: { enterprise: enterpriseRecaptcha } = {} } = window;
      if (!enterpriseRecaptcha) {
        captchaEvent('recaptcha_library_not_loaded');
        return attempt === 1
          ? resolve(
              renderCaptchaCheckbox(
                analytics,
                flow,
                googleCaptchaSiteKey,
                attempt + 1,
              ),
            )
          : reject(errorReason);
      }

      enterpriseRecaptcha.ready(() => {
        captchaWidget = enterpriseRecaptcha.render(
          document.getElementById('recaptchaCheckbox'),
          {
            sitekey: googleCaptchaSiteKey,
          },
        );

        return resolve('ok');
      });

      return resolve(undefined);
    } catch (err: any) {
      logError(
        new Error('Error rendering recaptcha'),
        'error_rendering_recaptcha',
      ); // first argument with type Error
      return reject(errorReason);
    }
  });

export default renderCaptchaCheckbox;
